import { NUMBER_FIELDS } from './constants';

/**
 * Normalize and convert number fields to proper types
 */
export const parseDataRow = (row) => {
  const cleaned = { ...row };
  
  NUMBER_FIELDS.forEach(field => {
    if (cleaned[field] !== undefined && cleaned[field] !== '') {
      const num = Number(cleaned[field]);
      cleaned[field] = isNaN(num) ? '' : num;
    }
  });
  
  return cleaned;
};

/**
 * Get the next field to focus based on mode and current field
 */
export const getNextFieldForNavigation = (mode, currentField, isEnter = false, showAllFields = false) => {
  if (mode === 'HP') {
    if (currentField === 'Impact' && !isEnter) return 'Score';
    if (showAllFields && currentField === 'TotalDamage' && !isEnter) return 'CaptureKills';
    if (showAllFields && currentField === 'CaptureKills' && !isEnter) return 'DistanceMoved';
    if (currentField === 'DistanceMoved' && !isEnter) {
      return showAllFields ? null : 'OperatorValue';
    }
    if (currentField === 'OperatorValue' && isEnter) return 'OperatorValue';
  }
  
  if (mode === 'SND') {
    if (currentField === 'Impact' && !isEnter) return 'Score';
    if (currentField === 'Clutches1v1' && !isEnter) return 'Score';
  }
  
  if (mode === 'CTL') {
    if (currentField === 'Impact' && !isEnter) return 'Score';
    if (currentField === 'CaptureKills' && !isEnter) return 'Damage';
    if (currentField === 'OperatorValue' && isEnter) return 'OperatorValue';
  }
  
  return null;
};

/**
 * Get today's date in YYYY-MM-DD format for date inputs
 */
export const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

